import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=2109918b&scoped=true&"
import script from "./TreeView.vue?vue&type=script&lang=js&"
export * from "./TreeView.vue?vue&type=script&lang=js&"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=2109918b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109918b",
  null
  
)

export default component.exports